module.exports = __webpack_public_path__ + "static/media/ice-hockey.73365e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/ice-hockey.jpg
// module id = 692
// module chunks = 0